export const APPROVE_REQUEST = 'APPROVE_REQUEST';
export const APPROVE_REQUEST_FAILURE = 'APPROVE_REQUEST_FAILURE';
export const APPROVE_REQUEST_SUCCESS = 'APPROVE_REQUEST_SUCCESS';

export const DECLINE_REQUEST = 'DECLINE_REQUEST';
export const DECLINE_REQUEST_FAILURE = 'DECLINE_REQUEST_FAILURE';
export const DECLINE_REQUEST_SUCCESS = 'DECLINE_REQUEST_SUCCESS';

export const GET_DONE_APPROVALS_REQUEST = 'GET_DONE_APPROVALS_REQUEST';
export const GET_DONE_APPROVALS_REQUEST_FAILURE = 'GET_DONE_APPROVALS_REQUEST_FAILURE';
export const GET_DONE_APPROVALS_REQUEST_SUCCESS = 'GET_DONE_APPROVALS_REQUEST_SUCCESS';

export const GET_TODO_APPROVALS_REQUEST = 'GET_TODO_APPROVALS_REQUEST';
export const GET_TODO_APPROVALS_REQUEST_FAILURE = 'GET_TODO_APPROVALS_REQUEST_FAILURE';
export const GET_TODO_APPROVALS_REQUEST_SUCCESS = 'GET_TODO_APPROVALS_REQUEST_SUCCESS';
